(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-categories"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.home-categories__toggle').forEach(function (btn) {
    var section = btn.closest('.home-categories-section');
    var text = btn.querySelector('.home-categories__toggle-text');
    if (!section || !text) return;

    btn.addEventListener('click', function () {
      var expanded = section.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      text.textContent = expanded ? btn.dataset.labelLess : btn.dataset.labelMore;
      // Bij inklappen terug naar de categorieen scrollen, anders sta je onder de sectie
      if (!expanded) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
